import { Route as PublicRoute } from 'react-router-dom';

import { Privacy } from '../lazyLoaded';
import { PATH_NAME } from '../pathNames';

const PrivacyRoute = () => (
  <PublicRoute
    exact
    path={PATH_NAME.PRIVACY}
    component={(props: JSX.IntrinsicAttributes) => <Privacy {...props} />}
  />
);
export default PrivacyRoute;
